<template>
  <div class="table-filter-wrap">
    <div v-if="$store.getters.getMarketplaceProductsCommonList.total" class="pagination-wrap mt-3">
      <Pagination
          :count="$store.getters.getMarketplaceProductsCommonList.total"
          :perPage="$store.getters.getMarketplaceProductsForPage"
          :loading="$store.getters.getMarketplaceProductsLoading"
          @paginate="(page) => {$emit('paginate', page)}"
      />
    </div>

    <template v-if="$store.getters.getMarketplaceProducts.length > 0 && $store.getters.getMarketplaceProductsLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
          'etsyListing_listingId',
          'etsyListing_title',
          'etsyListing_price',
          'etsyListing_qTy',
          'etsyListing_image',
          'common_manage',
          'common_edit',
          'common_delete',
          'common_copy',
          'common_showMore',
        ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('etsyListing_listingId.localization_value.value') }}</th>
            <th>{{ $t('etsyListing_title.localization_value.value') }}</th>
            <th class="white-space-line text-right">{{ $t('etsyListing_price.localization_value.value') }}</th>
            <th class="white-space-line text-right">{{ $t('etsyListing_qTy.localization_value.value') }}</th>
            <th>{{ $t('etsyListing_image.localization_value.value') }}</th>
            <th width="100">{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in $store.getters.getMarketplaceProducts"
                :key="index"
                :class="{'site-table__draft-row' : item['state'] === 'draft'}"
            >
              <td>
                <div class="table-row">
                  <LabelCircle :color="'green'" :value="'A'" class="mr-1"
                               v-if="item['state'] === 'active'"
                  />
                  <StatusIcoBtn :type="'cancel'" class="mr-1 pb-1"
                                v-else
                  />

                  <ValueHelper
                      :value="'#' + item['id']"
                  />
                </div>
              </td>
              <td>
                <div>
                  <TooltipTextHelper
                      class="etsy-listings-title"
                      v-if="item['title']"
                      :text="item['title']"
                      :paragraph="item['title']"
                      :styleClass="'white-space-normal style-ellipsis'"
                  />
                  <ValueHelper
                      v-else
                  />
                </div>
               <div v-if="item.is_private">
                 <a class="site-link" :href="item.url_key" target="_blank">ukrainiantreasures.com</a>
               </div>
              </td>
              <td align="right">
                <ValueHelper
                    :value="item['price']"
                />
              </td>
              <td align="right">
                <ValueHelper
                    :value="item['quantity']"
                />
              </td>
              <td>
<!--                <div class="table-img w-50px" v-if="item['Images'][0]">-->
<!--                  <div class="table-img__i">-->
<!--                    <img :src="item['Images'][0]['url_75x75']">-->
<!--                  </div>-->
<!--                </div>-->
<!--                <template v-else>-->
<!--                  <ValueHelper/>-->
<!--                </template>-->
              </td>
              <td class="manage-row">
                <div class="table-right table-manage-list table-manage-list--small">

                  <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                                 :key="$store.getters.getGlobalUpdateManagerButton">
                    <template slot="item">
                      <LinkButton
                          :value="$t('common_edit.localization_value.value')"
                          :type="'edit'"
                          :link="$store.getters.GET_PATHS.marketplaceProducts + `/${shopId}` + `/${item['id']}`"
                          v-bind:class="{'disabled-btn' : $store.getters.getMarketplaceProductsBtn}"
                      />
                    </template>
                    <template slot="item">
                      <LinkButton
                          :value="$t('common_delete.localization_value.value')"
                          :type="'delete'"
                          @click.native="removeItem(item.id)"
                          v-bind:class="{'disabled-btn' : $store.getters.getMarketplaceProductsBtn}"
                      />
                    </template>
<!--                    <template slot="item">-->
<!--                      <LinkButton-->
<!--                          :value="$t('common_copy.localization_value.value')"-->
<!--                          :type="'copy'"-->
<!--                          @click.native="cloneItem(parseInt(shopId), parseInt(item['listing_id']))"-->
<!--                          v-bind:class="{'disabled-btn' : $store.getters.getMarketplaceProductsBtn}"-->
<!--                      />-->
<!--                    </template>-->
                  </ManagerButton>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getMarketplaceProducts"
                 :key="index"
                 :class="{'draft-row' : item['state'] === 'draft'}"
            >
              <MarketplaceProductsTableMobile
                  :item="item"
                  :shopId="shopId"
                  @removeItem="removeItem(parseInt(shopId), parseInt(item['listing_id']))"
              />
<!--                  @cloneItem="cloneItem(parseInt(shopId), parseInt(item['listing_id']))"-->
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                v-if="$store.getters.getMarketplaceProductsCommonList.next_page_url !== null && $store.getters.getMarketplaceProducts.length > 0"
                @click.native="$emit('showMore')"
                v-bind:class="{'disabled-btn' : $store.getters.getNextMarketplaceProductsPage}"
                :count="$store.getters.getMarketplaceProductsForPage"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="$store.getters.getMarketplaceProductsLoading === false && $store.getters.getMarketplaceProducts.length === 0">
      <NoResult
          class="pt-4"
          :countFilterParams="countFilterParams"
          :title="$t('common_noDataYet.localization_value.value')"
          :titleWithFilter="$t('common_noResult.localization_value.value')"
          :text="$t('common_noDataYetTxt.localization_value.value')"
          :textWithFilter="$t('common_noResultSeems.localization_value.value')"
          @resetFilter="$emit('resetFilter')"
      />
    </template>
  </div>
</template>

<script>
import ShowMore from "../../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
import LinkButton from "../../../../../../../UI/buttons/LinkButton/LinkButton";
import ManagerButton from "../../../../../../../UI/buttons/ManagerButton/ManagerButton";
import {mixinDetictingMobile} from '../../../../../../../../mixins/mobileFunctions'
import StatusIcoBtn from "../../../../../../../UI/status/StatusIcoBtn/StatusIcoBtn";
import LabelCircle from "../../../../../../../coreComponents/LabelCircle/LabelCircle";
import ValueHelper from "../../../../../../../coreComponents/ValueHelper/ValueHelper";
import TooltipTextHelper from "../../../../../../../coreComponents/TooltipTextHelper/TooltipTextHelper";
import MarketplaceProductsTableMobile from "./MarketplaceProductsTableMobile/MarketplaceProductsTableMobile";
import NoResult from "../../../../../../../coreComponents/NoResult/NoResult";
import {marketplaceProductsMixin} from "@/mixins/marketplaceProductsMixins/marketplaceProductsMixin";
import Pagination from "@/components/coreComponents/Pagination/Pagination";


export default {
  name: "MarketplaceProductsTable",

  components: {
    Pagination,
    TooltipTextHelper,
    ValueHelper,
    ShowMore,
    LinkButton,
    ManagerButton,
    StatusIcoBtn,
    LabelCircle,
    MarketplaceProductsTableMobile,
    NoResult,
  },

  mixins: [mixinDetictingMobile, marketplaceProductsMixin],

  props: {
    countFilterParams: Number,
    shopId: [Number, String],
  },

  data() {
    return {
      orderId: '',
      showFilter: false,
      isMobile: false,
      showContent: false,
    }
  },

  methods: {}

}
</script>

<style lang="scss" scoped>

.site-table thead th,
.site-table tbody td {
  padding-right: 5px;
  padding-left: 5px;
}
.table-manage-list .manager-btn {
  width: 300px;
  //width: 240px;
}
@media (max-width: 1400px) {
  .table-manage-list .manager-btn{
    max-width: 200px;
  }
}

@media(max-width: 1600px) {
  .manage-row,
  .products-table .table-manage-list .manager-btn {
    width: 80px;
  }
}
.site-table thead th:first-child,
.site-table tbody td:first-child {
  padding-right: 0;
  padding-left: 10px;
}
.site-table thead th:last-child,
.site-table tbody td:last-child {
  padding-right: 0;
}

.etsy-listings-title{
  max-width: 350px;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
